import { render, staticRenderFns } from "./OACustomer.vue?vue&type=template&id=d54b3f58&scoped=true&"
import script from "./OACustomer.vue?vue&type=script&lang=js&"
export * from "./OACustomer.vue?vue&type=script&lang=js&"
import style1 from "./OACustomer.vue?vue&type=style&index=1&id=d54b3f58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54b3f58",
  null
  
)

export default component.exports